import { configureStore } from "@reduxjs/toolkit";
import authSlice from "./Slice/authSlice";

const store = configureStore({
	reducer: {
		authSlice: authSlice,
	},
});
export default store;
